import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Operario`, method: 'GET', body: null, token: token})
}
